<template>
    <div class="products-info-page">
        <div class="page-block ">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="body-info">
                    <div class="info-title">{{info.name}}</div>
                    <div class="info-text">
                        {{info.introduction}}
                    </div>
                    <div class="info-btn" @click="toBuy" v-if="channelWidth>768">询价购买</div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
        <div class="page-block info-header-tab" :class="[scrollTop > 210?'show-tab':'hidden-tab']">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="tab-body-info">
                    <div class="info-title">{{info.name}}</div>
                    <div class="info-btn" @click="toBuy">询价购买</div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
        <div class="page-block page-content">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="body-block">
                    <div class="block-name">外观</div>
                    <div class="block-show appearance">
                        <img :src="item" v-for="item in info.appearance"/>
<!--                        <img :src="productsImage2"/>-->
                    </div>
                </div>
                <div class="body-block">
                    <div class="block-name">产品特点</div>
                    <div class="block-show">
                       {{info.characteristic}}
                    </div>
                </div>
                <div class="body-block norms" >
                    <div class="block-name">产品规格</div>
                    <div class="block-show ">
                        <img :src="item" v-for="item in info.norms"/>
                    </div>
                </div>

            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import ProductsImage1 from '../../image/common/products_image1.png'
    import ProductsImage2 from '../../image/common/products_image2.png'
    import NormsImage1 from '../../image/common/norms1.png'
    import NormsImage2 from '../../image/common/norms2.png'

    export default {
        name: "products-page",
        data(){
            return{
                productsImage1:ProductsImage1,
                productsImage2:ProductsImage2,
                normsImage1:NormsImage1,
                normsImage2:NormsImage2,
                scrollTop:0,//页面滚动距离
                info:null,
                infoStr:'',
                channelWidth:null
            }
        },
        created() {
            if(this.$route.query.value && !this.$utils.isEmpty(this.$route.query.value)){
                this.info = this.$utils.decodeURIAndParse(this.$route.query.value);
                this.infoStr = this.$route.query.value
            }

        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        this.timer = false;
                    }, 400);
                }
            }
        },
        mounted(){
            //触发获取页面滚动
            window.addEventListener('scroll',this.handleScroll);
            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;
        },
        methods:{
            /**
             * 获取页面滚动
             */
            handleScroll(){
                let scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop;
                this.scrollTop = scrollTop;
            },
            /**
             * 跳转购买页面
             */
            toBuy(){
                this.$router.push({name:'buy',query:{value:this.infoStr}});
            }
        }
    }
</script>

<style lang="scss" src="./products-info-page.scss" scoped>

</style>
